/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { ControlledVocab } from "@folio/stripes/smart-components";
import { IntlConsumer, TitleManager } from "@folio/stripes/core";
import { getSourceSuppressor } from "@folio/stripes/util";

import { RECORD_SOURCE } from "../constants";

class InstanceRelationshipTypesSettings extends React.Component {
  static propTypes = {
    stripes: PropTypes.shape({
      connect: PropTypes.func.isRequired,
      hasPerm: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.connectedControlledVocab = props.stripes.connect(ControlledVocab);
  }

  render() {
    const hasPerm = this.props.stripes.hasPerm("ui-inventory.settings.list");
    const suppress = getSourceSuppressor([
      RECORD_SOURCE.FOLIO,
      RECORD_SOURCE.CONSORTIUM,
    ]);

    return (
      <IntlConsumer>
        {(intl) => (
          <TitleManager
            page={intl.formatMessage({
              id: "ui-inventory.settings.inventory.title",
            })}
            record={intl.formatMessage({
              id: "ui-inventory.instanceRelationshipTypes",
            })}
          >
            <this.connectedControlledVocab
              {...this.props}
              baseUrl="instance-relationship-types"
              records="instanceRelationshipTypes"
              label={
                <FormattedMessage id="ui-inventory.instanceRelationshipTypes" />
              }
              labelSingular={intl.formatMessage({
                id: "ui-inventory.instanceRelationshipType",
              })}
              objectLabel={<FormattedMessage id="ui-inventory.instances" />}
              visibleFields={["name"]}
              columnMapping={{
                name: intl.formatMessage({ id: "ui-inventory.name" }),
              }}
              hiddenFields={["description", "numberOfObjects"]}
              nameKey="name"
              id="instance-relationship-types"
              sortby="name"
            />
          </TitleManager>
        )}
      </IntlConsumer>
    );
  }
}

export default InstanceRelationshipTypesSettings;
